import React from "react";
import TextField from "@mui/material/TextField";

interface NumberFieldProps {
  name: string;
  value: string | number;
  label: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  placeholder?: string;
  classes?: { textField?: string; input?: string };
}

function NumberField({
  name,
  value,
  label,
  onChange,
  error,
  placeholder,
  classes,
}: NumberFieldProps) {
  const validate = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = evt.target;
    const regex = /^[0-9]+$/;
    if (value.match(regex) || value === "") {
      onChange(evt);
    }
  };

  return (
    <TextField
      fullWidth
      variant="outlined"
      type="text"
      name={name}
      value={value}
      label={label}
      placeholder={placeholder}
      onChange={validate}
      helperText={error}
      error={!!error}
      sx={{ bgcolor: "background.paper" }}
    />
  );
}

export default NumberField;
